import { useCallback, useEffect } from 'react';

const importGroupsManagement = () => import("GroupsManagement");

// preloads the GroupsManagement module when the user scrolls to the bottom of the groups list
export default function useLoadGroupsManagementOnScroll(scrollRef) {
  const handleScroll = useCallback(() => {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        const isAtBottom = Math.abs(scrollHeight - clientHeight - scrollTop) < 1;
  
        if (isAtBottom) {
          importGroupsManagement();
        }
      }
    }, [scrollRef]);
  
    useEffect(() => {
      const element = scrollRef.current;
      if (element) {
        element.addEventListener("scroll", handleScroll);
        return () => {
          element.removeEventListener("scroll", handleScroll);
        };
      }
    }, [handleScroll, scrollRef]);
  
  return null;
}